module.exports = __webpack_public_path__ + "static/media/proveoppgave-2.331ddf6a.mp3";